import React, { Component, PureComponent } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { Utils } from "arv-reactcomponents";

import { PDP_RETURNS } from "npmlinks-constants";

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));

@inject("CommonStore")
@observer
class FinerDetailsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewMore: false,
    };
    this.viewMoreClick = this.viewMoreClick.bind(this);
    this.showViewMoreButton = this.showViewMoreButton.bind(this);
  }

  componentDidMount() {
    const { isDesktop } = this.props.CommonStore;
    if (isDesktop) {
      return null;
    }
    const container = document.querySelectorAll(
      ".nw-pdp-desktopaccordiondetails",
    );
    this.offsetHeight = container && container[0] && container[0].offsetHeight;
    if (this.offsetHeight > 450) {
      this.showViewMoreButton();
    }
    return null;
  }

  get showViewMore() {
    return (this.state.viewMore && "nwc-active") || "nwc-hide";
  }

  get addFixedHeight() {
    return (this.state.viewMore && "nw-pdp-accordionfixedheight") || "";
  }

  viewMoreClick() {
    this.setState({
      viewMore: false,
    });
  }

  showViewMoreButton() {
    this.setState({
      viewMore: true,
    });
  }

  render() {
    const { props } = this;
    const finerDetails =
      props.PdpData &&
      props.PdpData.mainStyle &&
      props.PdpData.mainStyle.finerDetails;

    if (!finerDetails) return null;

    Object.keys(finerDetails).forEach(key => {
      if (!finerDetails[key]) delete finerDetails[key];
    });
    return (
      <section
        ref={context => {
          this.wrapperRef = context;
        }}
        className={`nw-pdp-desktopaccordiondetails nwc-custom-scrollbar ${
          props.className
        } ${this.addFixedHeight}`}
      >
        {Object.keys(finerDetails).map(key => (
          <div
            key={key}
            className={`nw-pdp-desktopaccordiondetailssection ${
              props.className
            }`}
          >
            <h3
              className={`nw-pdp-desktopaccordiondetailstitle ${
                props.className
              }`}
            >
              {finerDetails[key].title}
            </h3>
            <ul
              className={`nw-pdp-desktopaccordiondetailsul ${props.className}`}
            >
              {finerDetails[key].list &&
                finerDetails[key].list.map(item => (
                  <li
                    className={`nw-pdp-desktopaccordiondetailsli ${
                      props.className
                    }`}
                    key={item}
                  >
                    {item}
                  </li>
                ))}
            </ul>
          </div>
        ))}
        <div
          className={`nw-pdp-accordioncontentmore nw-mobile-only ${
            this.showViewMore
          }`}
          role="presentation"
          onKeyPress={Utils.noop}
          onClick={this.viewMoreClick}
        >
          Read More
        </div>
      </section>
    );
  }
}

const FinerDetails = {
  component: FinerDetailsComponent,
  wrapper: FinerDetailsComponent.wrappedComponent,
  getFinalComponent,
};

@inject("CommonStore")
@observer
class AboutComponent extends Component {
  render () {
    const { props } = this;
    const about =
      props.PdpData && props.PdpData.mainStyle && props.PdpData.mainStyle.about;
    const story = about && about.story;
    return (
      <section className={`nw-pdp-desktopaccordionstory ${props.className}`}>
        {/* <Img className="nw-pdp-accordionimg" src={about.images.logo} index={0} /> */}
        <p className={`nw-pdp-desktopaccordionstorydata ${props.className}`}>
          {story}
        </p>
      </section>
    );
  }
}

const About = {
  component: AboutComponent,
  wrapper: AboutComponent.wrappedComponent,
  getFinalComponent,
};

@inject("CommonStore")
@observer
class ReturnsComponent extends Component {
  render () {
    const { props } = this;
    const returnable =
      props.PdpData &&
      props.PdpData.mainStyle &&
      props.PdpData.mainStyle.returnable;
    const data = returnable
      ? PDP_RETURNS.returnPolicy
      : PDP_RETURNS.noReturnPolicy;
    return (
      <section className={`nw-pdp-desktopaccordionstory ${props.className}`}>
        {/* <i
          className={`icomoon-delivery-web nw-pdp-desktopaccordionreturnicon ${
            props.className
          }`}
        /> */}
        <p
          className={`nw-pdp-desktopaccordionstorydata ${props.className}`}
          dangerouslySetInnerHTML={{ __html: data }}
        />
      </section>
    );
  }
}

const Returns = {
  component: ReturnsComponent,
  wrapper: ReturnsComponent.wrappedComponent,
  getFinalComponent,
};

@inject("CommonStore")
@observer
class SaysComponent extends Component {
  render() {
    const { props } = this;
    const data =
      props.PdpData && props.PdpData.mainStyle && props.PdpData.mainStyle.story;
    return (
      <section className={`nw-pdp-desktopaccordionstory ${props.className}`}>
        <p className={`nw-pdp-desktopaccordionstorydata ${props.className}`}>
          {data}
        </p>
      </section>
    );
  }
}

@inject("CommonStore")
@observer
class ManufacturerDetailsComponent extends PureComponent {
  render() {
    const { props } = this;
    const { manufacturerDetails = "" } = props.PdpData.mainStyle;
    return (
      <section className={`nw-pdp-desktopaccordionstory ${props.className}`}>
        <p className={`nw-pdp-desktopaccordionstorydata ${props.className}`}>
          {manufacturerDetails}
        </p>
      </section>
    );
  }
}


const ManufacturerDetails = {
  component: ManufacturerDetailsComponent,
  wrapper: ManufacturerDetailsComponent.wrappedComponent,
  getFinalComponent,
};

const Says = {
  component: SaysComponent,
  wrapper: SaysComponent.wrappedComponent,
  getFinalComponent,
};

SaysComponent.propTypes = {
  className: PropTypes.string.isRequired,
  PdpData: PropTypes.shape({
    mainStyle: PropTypes.shape({
      story: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

ReturnsComponent.propTypes = {
  className: PropTypes.string.isRequired,
  PdpData: PropTypes.shape({
    mainStyle: PropTypes.shape({
      returnable: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

AboutComponent.propTypes = {
  className: PropTypes.string.isRequired,
  PdpData: PropTypes.shape({
    mainStyle: PropTypes.shape({
      about: PropTypes.shape({}).isRequired,
    }).isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

FinerDetailsComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

ManufacturerDetailsComponent.propTypes = {
  className: PropTypes.string,
  PdpData: PropTypes.shape({
    mainStyle: PropTypes.shape({
      manufacturerDetails: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const AccordionContents = {
  FinerDetails,
  About,
  Returns,
  Says,
  ManufacturerDetails,
};
export default AccordionContents;



// WEBPACK FOOTER //
// ./src/component/PdpAccordion/AccordionContents/index.js